
















import Vue from 'vue';
import scheduleClient from '../apis';
import WxTemplate from '../models/WxTemplate';
import RuleList from '../components/settings/List.vue';
import RuleCreate from '../components/settings/create/index.vue';

export default Vue.extend({
  components: {
    RuleList,
    RuleCreate,
  },
  data() {
    return {
      showCreatePage: false,
      showSelectType: true,
    };
  },
  methods: {
    refreshPage() {
      if(this.$refs.ruleListRef) {
        (this.$refs.ruleListRef as any).loadRules();
      }
    },
    showEdit() {
      this.showCreatePage = true;
      this.showSelectType = false;
    },
    showCreate() {
      this.$store.commit('RESET_SCHEDULE_RULE');
      this.showSelectType = true;
      this.showCreatePage = true;
    },
    setShowSelectType(status: boolean) {
      this.showSelectType = status;
    },
    loadTemplates() {
      scheduleClient.getTemplates().success((r) => {
        const wxTemplates: WxTemplate[] = [];
        const templateList = r.templateList;
        for (const tpl of templateList) {
          wxTemplates.push(new WxTemplate(tpl));
        }
        this.$store.commit('UPDATE_WX_TEMPLATES', wxTemplates);
      });
    },
  },
  mounted() {
    this.loadTemplates();
  },
});
